export function isJsonString(str) {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
}
export function parseIfJsonString(str) {
    if (isJsonString(str)) {
        return JSON.parse(str);
    }
    return str;
}
